<template>
    <div class="container-fluid">
        <div class="row pt-2 text-start mb-2">
            <div class="col-2">
                <h5>
                    <span class="badge rounded-pill text-white p-2 px-3" style="background:Coral;">
                    <b>Test Profile : เทสตรวจ</b>
                    </span>
                </h5>
            </div>
            <div class="col">
                  <!-- แสดงปุ่มย้ายห้องคลิก Checkbox แถว -->
                  <div class="btn-group" role="group" v-if="ItemTest_selectedlist.length>0">
                    <button id="MoveRoom" type="button"
                      class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="fa fa fa-retweet me-2"></i>ย้ายไปที่ห้องตรวจ.. <span class="badge rounded-pill bg-warning ms-2">{{ItemTest_selectedlist.length}}</span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <li v-for="item in roomtypeList" :key="item.id"><a class="dropdown-item" @click="changeRoomtypeForItemTestSelected(item)">{{item.room_name}}</a></li>
                    </ul>
                  </div>
                <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#exampleModal" @click="newRecord()" style="width:250px;">New</button>
            </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="container-fluid p-2 border border-2 border-secondary shadow" style="height: 800px;">
              <div class="mh-100 vh-100 overflow-auto ">
                <table id="myTable" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;font-size:90%;">
                    <thead class="text-dark" style="background:NavajoWhite">
                    <tr>
                        <th class="text-start" style="width:10px;" hidden>Seq.</th>
                        <th class="text-start" style="width:10px;" hidden>Seq.</th>
                        <th style="width:10px;"></th>
                        <th style="width:20px;">แก้ไข</th>
                        <th class="text-start" style="width:100px;">อยู่ในชุดตรวจ</th>
                        <th style="width:50px;">ใช้เป็นชุดตรวจเดี่ยว</th>
                        <th style="width:60px;">รหัส</th>
                        <th class="text-start" style="width:200px;">ชื่อเทส</th>
                        <th class="text-start" style="width:100px;">ห้องตรวจทางคลินิก</th>
                        <th class="text-start" style="width:80px;">ชนิดข้อมูล</th>
                        <th style="width:50px;">หน่วย</th>
                        <th class="text-start" style="width:200px;">ค่าปกติหลักหรือเพศชาย</th>
                        <!-- <th class="text-start" style="width:100px;">Min / Max</th> -->
                        <th class="text-start" style="width:200px;">ค่าปกติเพศหญิง</th>
                        <!-- <th class="text-start" style="width:100px;">Min / Max</th> -->
                        <th style="width:20px;">ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                      <template v-for="item in datalists" :key="item.itemtestid">
                      <tr  v-bind:data-id="item.ItemTestID" @click="tableChanged($event, item)">
                          <td class="text-start py-1" hidden>{{ item.room_seq }}</td>
                          <td class="text-start py-1" hidden>{{item.Seq}}</td>
                          <td class="py-1">
                            <input class="mt-1" type="checkbox" title="คลิกเพื่อเลือกรายการ" v-model="ItemTest_selectedlist"
                              style="width:20px;height:20px;"
                              :name="'chkItemTest' + item.ItemTestID" :id="'chkItemTest' + item.ItemTestID" :value="item" autocomplete="off">
                          </td>
                          <td class="py-1">
                            <button type="button" class="btn btn-primary btn-sm py-0" id="Edit"
                              @click="editBtnClicked(item)"
                              data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</button>
                          </td>
                          <!-- อยู่ในชุดตรวจอะไรบ้าง -->
                          <td class="text-start py-1">
                            <!-- <span v-for="itemstr in item.TestCode_Strs.split(',')" :key="itemstr"
                              class="badge rounded-pill bg-secondary me-1" style="font-size:80%;">{{ itemstr }}
                            </span> -->
                            <select id="Testsuits" class="form-select p-0" name="Testsuits">
                              <option :key="0" :value="item.TestCode_Strs">{{ item.TestCode_Strs }}</option>
                              <option v-for="itemstr in item.TestCode_Strs.split(',')" :key="itemstr" :value="itemstr">
                                <span class=""><b>{{ itemstr }}</b></span>
                              </option>
                            </select>
                          </td>
                          <td class="text-end py-1">
                            <span v-if="item.TestID==0"></span>
                            <span v-if="item.TestID>0" class="me-2"><i class="fa fa-check text-primary" style="font-size:12px"></i></span>
                            <button v-if="item.TestID==0" type="button" class="btn btn-outline-primary btn-sm px-2 py-0 float-end" @click="applyAsTestSuit(item)"
                              id="ApplyTest" title="ต้องการสร้างชุดตรวจจากเทสนี้"><i class="fa fa-thermometer"></i></button>
                            <button v-if="item.TestID>0" type="button" class="btn btn-outline-warning btn-sm px-2 py-0 float-end" @click="updateAsTestSuit(item)"
                              id="UpdateTest" title="ต้องการปรับปรุงข้อมูลชุดตรวจจากเทสนี้"><i class="fa fa-thermometer"></i></button>
                          </td>
                          <td class="text-start py-1">{{ item.ItemTestCode }}</td>
                          <td class="text-start py-1"><b> {{ item.ItemTestName }}</b></td>
                          <td class="text-start py-1"><b> {{ item.room_name }}</b></td>
                          <td class="py-1">{{ arrDataType[item.ValueType] }}</td>
                          <td class="text-start py-1">{{ item.Unit }}</td>
                          <td class="text-start py-1" style="font-size-80%">
                            <span class="text-primary">{{ item.NormalValue }} </span> <br>
                            <span class="me-2" v-if="item.MinValue || item.MaximumValue"> MIN : <b>{{ item.MinValue }} </b> </span>
                            <span class="me-2" v-if="item.MinValue || item.MaximumValue"> MAX : <b>{{item.MaximumValue}} </b> </span>
                          </td>
                          <td class="text-start py-1" style="font-size-80%">
                            <span class="text-primary">{{ item.NormalValue2 }} </span> <br>
                            <span class="me-2" v-if="item.MinValue2 || item.MaximumValue2"> MIN : <b>{{ item.MinValue2 }} </b> </span>
                            <span class="me-2" v-if="item.MinValue2 || item.MaximumValue2"> MAX : <b>{{item.MaximumValue2}} </b> </span>
                          </td>
                          <td class="py-1">
                            <button class="btn btn-danger btn-sm py-0" id="Delete" @click="cancelRecord(item)">Del</button>
                          </td>
                      </tr>
                      </template>
                    </tbody>
                </table>
              </div>
            </div>
            <!-- ========================================== -->
          </div>
          <!-- ปุ่มจัดลำดับก่อนหลัง ในห้องตรวจ -->
          <!--   เรียงเพื่อให้ดูในหน้านี้ง่ายเท่านั้น ตอนพิมพ์เรียงตาม Seq ในชุดตรวจ -->
          <div class="container mt-3" :hidden="roomtypeID == 0 || datalists.length <= 1">
            <div class="btn-group mb-3" role="group" aria-label="Basic outlined example">
              <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งขึ้น" @click="upNdown('up');">Up</button>
              <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งลง" @click="upNdown('down');">Down</button>
              <button type="button" class="btn btn-primary ms-2" title="จัดเก็บลำดับที่เปลี่ยนแปลง" @click="applySeqItems();">บันทึกลำดับที่จัดเรียง</button>
            </div>
            <p class="mb-4" style="font-size:90%">คำแนะนำ : การเรียงลำดับให้แสดงข้อมูลครบทุกแถว โดยการเปลี่ยนจำนวนแถวที่แสดงที่มุมซ้ายด้านบนของตาราง เป็น "Show All entries"</p>
          </div>
        </div>

      <!-- ปุ่ม Download -->
      <div class="row mt-3">
        <div class="col">
          <vue-excel-xlsx class="btn btn-outline-secondary btn-sm mb-2 float-start" v-if="datalists!==null" title="Download to Excel File"
            :data="datalists"
            :columns="columns"
            :filename="'tests_list'"
            :sheetname="'sheetname'"
            >
            <i class="fa fa-download"></i> Download
          </vue-excel-xlsx>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <div id="exampleModal" class="modal" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header" style="background-color:Gainsboro">
            <h5 class="modal-title">Test Profiles</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-start">
            <form id="fmTest" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <input type="text" hidden class="form-control" placeholder="" name="action" v-model="action" >
                <input type="text" hidden class="form-control" placeholder="" name="ItemTestID" v-model="curRecord.ItemTestID" >
                <div class="row mb-2">
                    <!-- ***************** พาเนลซ้าย *************** -->
                    <div class="col-sm-6">
                        <div class="row mb-2">
                            <div class="col-6 text-start">
                              <div class="form-group">
                                <label class="mr-sm-2">รหัส / ชื่อเทส :</label>
                                <input type="text" id="ItemTestCode" class="form-control form-control-sm" placeholder="รหัสย่อเทส*" name="ItemTestCode" autocomplete="off" v-model="curRecord.ItemTestCode" required>
                              </div>
                            </div>
                            <div class="col-6 text-start">
                              <div class="form-group" hidden>
                                <label class="mr-sm-2">ราคาขาย :</label>
                                <input type="number" class="form-control form-control-sm" placeholder="ราคาขาย" name="SellPrice" autocomplete="off" v-model="curRecord.SellPrice" style="background:OldLace;">
                              </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col">
                              <div class="form-group">
                                <input type="text" class="form-control form-control-sm" placeholder="ชื่อเทส (อังกฤษ)*" name="ItemTestName" autocomplete="off" v-model="curRecord.ItemTestName" required style="font-weight:bold;">
                                <input type="text" class="form-control form-control-sm" placeholder="ชื่อเทส (ไทย)" name="ItemTestName2" autocomplete="off" v-model="curRecord.ItemTestName2">
                              </div>
                            </div>
                        </div>
                        <label for="ValueType" class="">ชนิดข้อมูล :</label>
                        <div class="row mb-2 border m-1 p-2 text-start">
                            <div class="col">
                              <div class="d-flex mb-2">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" id="ValueType0" value="0" name="ValueType" v-model="curRecord.ValueType">
                                  <label class="form-check-label" for="ValueType0">ตัวเลข</label>
                                </div>
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" id="ValueType1" value="1"  name="ValueType"  v-model="curRecord.ValueType">
                                  <label class="form-check-label" for="ValueType1">ข้อความ</label>
                                </div>
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" id="ValueType2" value="2"  name="ValueType"  v-model="curRecord.ValueType">
                                  <label class="form-check-label" for="ValueType2">รายการเลือก</label>
                                </div>
                              </div>
                              <!-- ทศนิยมของประเภทข้อมูลแบบตัวเลข -->
                              <div class="row" v-if="curRecord.ValueType==0">
                                <div class="col">
                                    <div class="input-group input-group-sm">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text">ทศนิยม:</span>
                                    </div>
                                    <input type="number" class="form-control form-control-sm" title="จำนวนหลักทศนิยม" name="Decimals" v-model="curRecord.Decimals">
                                  </div>
                                </div>
                              </div>
                              <!-- PreAnswer ของประเภทข้อมูลแบบข้อความ -->
                              <div class="row" v-if="curRecord.ValueType==1">
                                <div class="col bg-warning" title="ป้อนข้อความผลแล็บไว้ล่วงหน้าสำหรับให้เลือกได้หลายข้อความ">
                                  <textarea v-model="curRecord.TextValueList" class="form-control" rows="2" name="TextValueList" placeholder="คำตอบสำหรับแสดงให้เลือก ex: Text1,Text2,Text3"></textarea>
                                </div>
                              </div>
                              <!-- รายการข้อความสำหรับรายการเลือก -->
                              <div class="row" v-if="curRecord.ValueType==2">
                                <div class="col bg-info" title="สำหรับนำไปแสดงผลเป็น Dropdown List">
                                  <textarea v-model="curRecord.ValueList" class="form-control" rows="2" name="ValueList" placeholder="ex: choice1,choice2,choice3"></textarea>
                                </div>
                              </div>
                            </div>
                        </div>
                        <!-- หน่วย, Method -->
                        <div class="row mb-2">
                          <div class="col">
                              <div class="input-group input-group-sm">
                                <span class="input-group-text" style="width:120px;">หน่วย:</span>
                                <input type="text" class="form-control form-control-sm" title="หน่วย" name="Unit" v-model="curRecord.Unit">
                              </div>
                              <div class="input-group mb-2 input-group-sm">
                                <span class="input-group-text" style="width:120px;">Method:</span>
                                <input type="text" class="form-control form-control-sm" title="Test Method" name="Method" v-model="curRecord.Method">
                              </div>
                          </div>
                        </div>
                        <!-- ห้องตรวจ -->
                        <div class="row">
                            <div class="col">
                              <div class="input-group mb-2 input-group-sm">
                                <span class="input-group-text" style="width:120px;">ห้องตรวจ (*)</span>
                                <select id="PriorityIdx" class="form-control form-select" name="PriorityIdx" v-model="curRecord.PriorityIdx">
                                    <option v-for="item in roomtypeList" v-bind:key="item.id" :value="item.id">{{ item.room_name }}</option>
                                </select>
                              </div>

                                <!-- <label for="PriorityIdx">ห้องตรวจ (*) </label>
                                <select id="PriorityIdx" class="form-control form-select" name="PriorityIdx" v-model="curRecord.PriorityIdx">
                                    <option v-for="item in roomtypeList" v-bind:key="item.id" :value="item.id">{{ item.room_name }}</option>
                                </select> -->
                            </div>
                        </div>
                    </div>
                    <!-- ***************** พาเนลขวา *************** -->
                    <div class="col-sm-6" style="background-color:#EBEBEB;">
                        <!-- ค่าปกติ Normal range#1  -->
                        <div class="row mt-3">
                          <div class="col">
                              <input type="radio" id="MinMaxType0" value="0" name="MinMaxType" v-model="curRecord.MinMaxType">
                              <label for="MinMaxType0">&nbsp; ใช้ค่าปกติ<b> เหมือนกัน</b> ทั้งชายและหญิง | เพศชาย</label>
                              <div class="input-group input-group-sm">
                                <span class="input-group-text" style="width:120px;">Normal Value :</span>
                                <input type="text" class="form-control form-control-sm" placeholder="ค่าปกติ (ข้อความ)" title="ค่าปกติ (ข้อความ)" name="NormalValue" autocomplete="off" v-model="curRecord.NormalValue">
                              </div>
                          </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col">
                                <div class="input-group input-group-sm">
                                  <span class="input-group-text" style="width:120px;">MIN value :</span>
                                  <input type="number" class="form-control form-control-sm" name="MinValue" v-model="curRecord.MinValue">
                                </div>
                                <div class="input-group input-group-sm">
                                  <span class="input-group-text" style="width:120px;">MAX value :</span>
                                  <input type="number" class="form-control form-control-sm" name="MaximumValue" v-model="curRecord.MaximumValue">
                                </div>
                            </div>
                        </div>
                        <!-- ค่าปกติ Normal range#2  -->
                        <div class="row">
                          <div class="col">
                              <input type="radio" id="MinMaxType1" value="1"  name="MinMaxType"  v-model="curRecord.MinMaxType">
                              <label for="MinMaxType1">&nbsp; ใช้ค่าปกติของชายและหญิง <b> ต่างกัน </b>| เพศหญิง</label>
                              <div class="input-group input-group-sm" v-if="curRecord.MinMaxType==1">
                                <span class="input-group-text" style="width:120px;">Normal Value :</span>
                                <input type="text" class="form-control form-control-sm" placeholder="ค่าปกติ (ข้อความ)" title="ค่าปกติ (ข้อความ)" name="NormalValue2" autocomplete="off" v-model="curRecord.NormalValue2">
                              </div>
                          </div>
                        </div>
                        <div class="row mb-2" v-if="curRecord.MinMaxType==1">
                            <div class="col">
                                <div class="input-group input-group-sm">
                                  <span class="input-group-text" style="width:120px;">MIN value :</span>
                                  <input type="number" class="form-control form-control-sm" name="MinValue2" v-model="curRecord.MinValue2">
                                </div>
                                <div class="input-group input-group-sm">
                                  <span class="input-group-text" style="width:120px;">MAX value :</span>
                                  <input type="number" class="form-control form-control-sm" name="MaximumValue2" v-model="curRecord.MaximumValue2">
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top:50px;">
                          <div class="col">
                            <input type="text" class="form-control form-control-sm" placeholder="คำแนะเมื่อค่าต่ำ" title="ข้อแนะนำเมื่อค่าต่ำ" name="AdviceMin" autocomplete="off" v-model="curRecord.AdviceMin">
                            <input type="text" class="form-control form-control-sm" placeholder="คำแนะเมื่อค่าสูง" title="ข้อแนะนำเมื่อค่าสูง" name="AdviceMax" autocomplete="off" v-model="curRecord.AdviceMax">
                          </div>
                        </div>
                    </div>
                </div>
            </form>
          </div>

          <div class="modal-footer" style="background-color:Gainsboro">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Tests1View',
  components: {

  },
  data () {
    return {
      columns: [
        { label: 'Code', field: 'ItemTestCode' },
        { label: 'Name', field: 'ItemTestName' },
        { label: 'Name2', field: 'ItemTestName2' },
        { label: 'ValueType', field: 'ValueType' },
        { label: 'TextValueList', field: 'TextValueList' },
        { label: 'ValueList', field: 'ValueList' },
        { label: 'Unit', field: 'Unit' },
        { label: 'NormalValue', field: 'NormalValue' },
        { label: 'MinValue', field: 'MinValue' },
        { label: 'MaximumValue', field: 'MaximumValue' },
        { label: 'MinValue2', field: 'MinValue2' },
        { label: 'MaximumValue2', field: 'MaximumValue2' },
        { label: 'Method', field: 'Method' }
      ],
      arrDataType: ['ตัวเลข', 'ข้อความ', 'รายการเลือก'],
      datalists: [],
      ItemTest_selectedlist: [], // กรณีเลือก checkbox หลายรายการเทส เพื่อเปลี่ยนห้องตรวจ
      curRecord: { },
      action: 'new'
    }
  },
  props: ['roomtypeList', 'roomtypeID'],
  mounted () {
    this.getTestsData()
  },
  methods: {
    changeRoomtypeForItemTestSelected (roomtypeRow) {
      // var self = this
      var arrTest = []
      // แปลงข้อมูลจากฟอร์ม
      for (var i = 0; i <= this.ItemTest_selectedlist.length - 1; i++) {
        // console.log(table.rows[i].getAttribute('data-id'))
        arrTest.push({
          ItemTestID: this.ItemTest_selectedlist[i].ItemTestID,
          roomtypeID: roomtypeRow.id,
          UserID: this.globalUserID
        })
      }
      // console.log(arrTest)

      var self = this
      Swal.fire({
        title: this.ItemTest_selectedlist.length + ' รายการ',
        text: 'คุณต้องการย้ายไปห้องตรวจ ' + roomtypeRow.room_name + '..ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/update_itemtest_changeroom.php',
            data: { request: JSON.stringify(arrTest) }
          }).done(function () {
            Swal.fire({
              text: 'ย้ายห้องตรวจเรียบร้อย',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    // จัดเก็บลำดับที่จัดเรียงใหม่
    applySeqItems () {
      // var self = this
      var arrTest = []
      // แปลงข้อมูลจากฟอร์ม
      var table = document.getElementById('myTable')
      for (var i = 1; i < table.rows.length; i++) {
        // console.log(table.rows[i].getAttribute('data-id'))
        arrTest.push({
          ItemTestID: table.rows[i].getAttribute('data-id'),
          Seq: i,
          UserID: this.globalUserID
        })
      }
      // console.log(arrTest)
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_testitems_seqinroom.php',
        data: { request: JSON.stringify(arrTest) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกลำดับใหม่เสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            self.$emit('onDataChangedEvent')
          })
        })
        .fail(function (resp) {
          console.log(resp)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    upNdown (direction) {
      var rows = document.getElementById('myTable').rows
      var parent = rows[this.index].parentNode
      if (direction === 'up') {
        if (this.index > 1) {
          parent.insertBefore(rows[this.index], rows[this.index - 1])
          // when the row go up the index will be equal to index - 1
          this.index = this.index - 1
        }
      }
      if (direction === 'down') {
        if (this.index < rows.length - 1) {
          parent.insertBefore(rows[this.index + 1], rows[this.index])
          // when the row go down the index will be equal to index + 1
          this.index = this.index + 1
        }
      }
    },
    // แสดงแถบสีว่า เลือก row นี้
    getSelectedRow (event, row) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      // console.log(event.target)
      // console.log(event.target.nodeName)
      // console.log(event.target.parentNode.nodeName === 'TR')
      if (event.target.parentNode.nodeName === 'TR') {
        this.index = event.target.parentNode.rowIndex
        var table = document.getElementById('myTable')
        for (var i = 1; i < table.rows.length; i++) {
          table.rows[i].style.backgroundColor = 'white'
          table.rows[i].style.color = 'black'
        }
        table.rows[this.index].style.backgroundColor = 'MediumBlue'
        table.rows[this.index].style.color = 'white'
      }
    },

    updateAsTestSuit (item) {
      console.log(JSON.stringify(item))
      var self = this
      Swal.fire({
        title: 'คุณแน่ใจหรือไม่...ที่จะปรับปรุงชุดตรวจจากเทสนี้? <br>' + item.ItemTestCode + ' | ' + item.ItemTestName,
        text: 'ชุดตรวจที่สร้างขึ้นจะมีเทสนี้เป็นพารามิเตอร์์เพียงเทสเดียว',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/test_apply_update_testsuit_masterdetail.php',
            data: { request: JSON.stringify(item), UserID: this.globalUserID }
          }).done(function () {
            Swal.fire({
              text: 'ปรับปรุงข้อมูลชุดตรวจเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              // self.getTestsData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    applyAsTestSuit (item) {
      console.log(JSON.stringify(item))
      var self = this
      Swal.fire({
        title: 'คุณแน่ใจหรือไม่...ที่จะสร้างชุดตรวจจากเทสนี้? <br>' + item.ItemTestCode + ' | ' + item.ItemTestName,
        text: 'ชุดตรวจที่สร้างขึ้นจะมีเทสนี้เป็นพารามิเตอร์์เพียงเทสเดียว',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/test_apply_insert_testsuit_masterdetail.php',
            data: { request: JSON.stringify(item), UserID: this.globalUserID }
          }).done(function () {
            Swal.fire({
              text: 'สร้างข้อมูลชุดตรวจเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              // self.getTestsData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.ItemTestName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_test.php',
            // url: 'http://localhost/vmedlab/src/service/setdata/cancel_test.php',
            // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/cancel_test.php',
            data: { id: item.ItemTestID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
            //   self.getTestsData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
    },
    editBtnClicked (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
    },
    tableChanged (event, row) {
      if (event.target.parentNode.nodeName !== 'TR') { // ต้องคลิกที่ <TD> เพื่อทำ HighLight แถว
        return
      }
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)

      // --------------------------------------- //
      this.ItemTest_selectedlist = [] // Clear Checkbox แถวที่เลือก
      // ================================ //
      //          การจัดลำดับ
      // แถบสี row ที่คลิก
      this.getSelectedRow(event, row)
    },
    getTestsData () {
      let phpFile = ''
      if (this.roomtypeID === 0 || this.roomtypeID === '0') {
        phpFile = 'getdata/tests_all.php'
      } else {
        phpFile = 'getdata/tests_where_roomtype.php'
      }
      MyApiClient.get(phpFile + '?C1=' + this.globalCorpID + '&roomtypeID=' + this.roomtypeID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.datalists = resp.data.response
          // setTimeout(function () { $('#myTable').DataTable() }, 0)
          setTimeout(function () {
            $('#myTable').DataTable(
              { lengthMenu: [[10, 25, 50, -1], [10, 25, 50, 'All']] },
              { order: [[0, 'asc'], [1, 'asc']] }
            )
          }, 0)
          // if (this.roomtypeID === 0 || this.roomtypeID === '0') {
          //   setTimeout(function () { $('#myTable').DataTable() }, 0)
          // }
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmTest').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_test.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // self.getTestsData()
            self.$emit('onDataChangedEvent')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}

</script>

<style>
.pagination{
    display: inline-flex;
}
div.dataTables_wrapper div.dataTables_paginate{
    text-align: center;
}
</style>
